<template>
  <div>
    <div id="donutApex"></div>
  </div>
</template>
<script>
export default {
  name: "Dounut Chart",
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    initChart() {
      var options = {
        series: [44, 55, 41, 17, 15],
        chart: {
          type: "donut",
          height: 360,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };

      var chart = new ApexCharts(document.querySelector("#donutApex"), options);
      chart.render();
    },
  },
};
</script>
